module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate-carousel ra-hub-carousel"
  }, [_c('VueSlickCarousel', _vm._b({
    on: {
      "afterChange": _vm.changeIndex
    }
  }, 'VueSlickCarousel', _vm.settings, false), _vm._l((_vm.slides), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "slide"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.handleClick(item.link)
        }
      }
    }, [_c('div', {
      staticClass: "slide-image",
      style: ('background-image: url(' + item.image + ')')
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "slide-copy"
  }, [_c('h4', [_vm._v(_vm._s(_vm.slides[_vm.slideIndex].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.slides[_vm.slideIndex].text))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-604b0107","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/hub/RaHubCarousel.vue
// module id = 693
// module chunks = 0